import React from 'react';
import { FormControl, InputAdornment, Input } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import styles from './Copy.module.scss';

const InputComponent = ({ value, handleChange = () => null }) => {
  return (
    <div className={styles.inputContainer}>
      <FormControl fullWidth>
        <Input
          value={value}
          onChange={handleChange}
          startAdornment={
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          }
          disableUnderline
          placeholder="Find within this transcription"
        />
      </FormControl>
    </div>
  );
};
export default InputComponent;
